import React, { useEffect } from "react";

import { Route, Routes, useLocation } from "react-router-dom";

import { Spinner } from "react-bootstrap";

import "./assets/scss/theme.scss";
import "./assets/fonts/IRANSansWeb/Iransansx.css";

const FallBackLoader = () => {
  return (
    <div
      className='d-flex justify-content-center align-items-center'
      style={{
        marginTop: "100px",
        width: "100%",
        height: "100%",
      }}
    >
      <Spinner animation='border' variant='primary' />
    </div>
  );
};
import RequireAuth from "./components/RequireAuth";
import PersistLogin from "./components/PersistLogin";

const NonAuthLayout = React.lazy(() => import("./components/NonAuthLayout"));
const Login = React.lazy(() => import("./pages/Authentication/Login"));
const LoginBehboud = React.lazy(() =>
  import("./pages/Authentication/LoginBehboud")
);
const LoginTavana = React.lazy(() =>
  import("./pages/Authentication/LoginTavana")
);
const Landing = React.lazy(() => import("./pages"));
const NotFound = React.lazy(() => import("./pages/NotFound"));
const VerticalLayout = React.lazy(() => import("./components/VerticalLayout/"));
// const VerticalLayoutNoSideBar = React.lazy(() =>
// 	import("./components/VerticalLayoutNoSideBar/")
// );
const Main = React.lazy(() => import("./pages/Main/index"));
const MainBehboud = React.lazy(() => import("./pages/MainBehboud/index"));
const MainTavana = React.lazy(() => import("./pages/MainTavana/index"));

const PatientList = React.lazy(() => import("./pages/PatientList/index"));
const LabServices = React.lazy(() => import("./pages/LabServices/index"));
const LabAdmit = React.lazy(() => import("./pages/LabAdmit/index"));
const LabMissedSamples = React.lazy(() =>
  import("./pages/LabMissedSamples/index")
);
const LabNormalUpdates = React.lazy(() =>
  import("./pages/LabNormalUpdates/index")
);
const QcPeerGroup = React.lazy(() => import("./pages/PeerGroupQC/index"));
const Trolley = React.lazy(() => import("./pages/Trolley/index"));

// const Login = React.lazy(() => import("./pages/Authentication/Login"));
const ChangePassword = React.lazy(() =>
  import("./pages/Authentication/ChangePassword")
);

const Users = React.lazy(() => import("./pages/Users/index"));
const Profile = React.lazy(() => import("./pages/Profile/index"));
// const Landing = React.lazy(() => import("./pages"));

const Dashboard = React.lazy(() => import("./pages/Dashboard/index"));
const LabAnnouncement = React.lazy(() =>
  import("./pages/LabAnnouncement/index")
);

const App = (props) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const FORMS = {
    Main: 0,
    MainBehboud: 100,
    MainTavana: 200,
    PatientList: 1,
    LabAdmit: 2,
    LabServices: 3,
    LabNormalUpdates: 4,
    ChangePassword: 5,
    LabMissedSamples: 6,
    QcPeerGroup: 7,
    Trolley: 8,
    LabAnnouncement: 9,
    Profile: 20,
    Dashboard: 14,
    Help: 21,
  };

  return (
    <React.Fragment>
      <Routes>
        <Route
          element={
            <React.Suspense fallback={<FallBackLoader />}>
              <NonAuthLayout />
            </React.Suspense>
          }
        >
          <Route
            path='/'
            element={
              <React.Suspense fallback={<FallBackLoader />}>
                <Landing />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/login'
            element={
              <React.Suspense fallback={<FallBackLoader />}>
                <Login />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/loginbehboud'
            element={
              <React.Suspense fallback={<FallBackLoader />}>
                <LoginBehboud />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/logintavana'
            element={
              <React.Suspense fallback={<FallBackLoader />}>
                <LoginTavana />
              </React.Suspense>
            }
          ></Route>
          <Route
            element={<RequireAuth RequiredFormId={FORMS.ChangePassword} />}
          >
            <Route path='/changePassword' element={<ChangePassword />}></Route>
          </Route>
        </Route>
        <Route element={<PersistLogin />}>
          <Route
            element={
              <React.Suspense fallback={<FallBackLoader />}>
                <VerticalLayout />
              </React.Suspense>
            }
          >
            <Route element={<RequireAuth RequiredFormId={FORMS.Main} />}>
              <Route
                path='/main'
                element={
                  <React.Suspense fallback={<FallBackLoader />}>
                    <Main />
                  </React.Suspense>
                }
              ></Route>
            </Route>
            <Route element={<RequireAuth RequiredFormId={FORMS.MainBehboud} />}>
              <Route
                path='/mainbehboud'
                element={
                  <React.Suspense fallback={<FallBackLoader />}>
                    <MainBehboud />
                  </React.Suspense>
                }
              ></Route>
            </Route>
            <Route element={<RequireAuth RequiredFormId={FORMS.MainTavana} />}>
              <Route
                path='/maintavana'
                element={
                  <React.Suspense fallback={<FallBackLoader />}>
                    <MainTavana />
                  </React.Suspense>
                }
              ></Route>
            </Route>

            <Route element={<RequireAuth RequiredFormId={FORMS.PatientList} />}>
              <Route
                path='/PatientList'
                element={
                  <React.Suspense fallback={<FallBackLoader />}>
                    {/* <MyVisitList /> */}
                    <PatientList />
                  </React.Suspense>
                }
              ></Route>
            </Route>

            <Route element={<RequireAuth RequiredFormId={FORMS.QcPeerGroup} />}>
              <Route
                path='/PeerGroupQC'
                element={
                  <React.Suspense fallback={<FallBackLoader />}>
                    {/* <MyVisitList /> */}
                    <QcPeerGroup />
                  </React.Suspense>
                }
              ></Route>
            </Route>

            <Route element={<RequireAuth RequiredFormId={FORMS.Trolley} />}>
              <Route
                path='/Trolley'
                element={
                  <React.Suspense fallback={<FallBackLoader />}>
                    {/* <MyVisitList /> */}
                    <Trolley />
                  </React.Suspense>
                }
              ></Route>
            </Route>

            <Route element={<RequireAuth RequiredFormId={FORMS.LabAdmit} />}>
              <Route
                path='/LabAdmit'
                element={
                  <React.Suspense fallback={<FallBackLoader />}>
                    {/* <MyVisitList /> */}
                    <LabAdmit />
                  </React.Suspense>
                }
              ></Route>
            </Route>

            <Route element={<RequireAuth RequiredFormId={FORMS.LabServices} />}>
              <Route
                path='/LabServices'
                element={
                  <React.Suspense fallback={<FallBackLoader />}>
                    {/* <MyVisitList /> */}
                    <LabServices />
                  </React.Suspense>
                }
              ></Route>
            </Route>
            <Route
              element={<RequireAuth RequiredFormId={FORMS.LabNormalUpdates} />}
            >
              <Route
                path='/LabNormalUpdates'
                element={
                  <React.Suspense fallback={<FallBackLoader />}>
                    {/* <MyVisitList /> */}
                    <LabNormalUpdates />
                  </React.Suspense>
                }
              ></Route>
            </Route>
            <Route
              element={<RequireAuth RequiredFormId={FORMS.LabMissedSamples} />}
            >
              <Route
                path='/LabMissedSamples'
                element={
                  <React.Suspense fallback={<FallBackLoader />}>
                    {/* <MyVisitList /> */}
                    <LabMissedSamples />
                  </React.Suspense>
                }
              ></Route>
            </Route>
            <Route
              element={<RequireAuth RequiredFormId={FORMS.LabAnnouncement} />}
            >
              <Route
                path='/LabAnnouncement'
                element={
                  <React.Suspense fallback={<FallBackLoader />}>
                    {/* <MyVisitList /> */}
                    <LabAnnouncement />
                  </React.Suspense>
                }
              ></Route>
            </Route>

            <Route element={<RequireAuth RequiredFormId={FORMS.Profile} />}>
              <Route
                path='/Profile'
                element={
                  <React.Suspense fallback={<FallBackLoader />}>
                    <Profile />
                    {/* <MyVisitList /> */}
                  </React.Suspense>
                }
              ></Route>
            </Route>

            <Route element={<RequireAuth RequiredFormId={FORMS.Dashboard} />}>
              <Route
                path='/Dashboard'
                element={
                  <React.Suspense fallback={<FallBackLoader />}>
                    {/* <MyVisitList /> */}
                    <Dashboard />
                  </React.Suspense>
                }
              ></Route>
            </Route>
          </Route>
        </Route>
        <Route
          path='*'
          element={
            <React.Suspense fallback={<FallBackLoader />}>
              <NotFound />
            </React.Suspense>
          }
        />
      </Routes>
    </React.Fragment>
  );
};

export default App;
